import React from 'react'

const CityWatter = ({ data }) => {
    const {
        backgroundImage
    } = data;
    return (
        <div
            className="feature-section__cta container-fluid"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
            <div className="container feature-section__cta-content-wrapper">
                <div className="feature-section__cta-content">
                </div>
            </div>
        </div>
    )
}

export default CityWatter